

export function routerConfig($routeProvider, $locationProvider) {
  'ngInject';

    $routeProvider
      .when('/login', {
        template: "<p-login></p-login>"
      })
      .when('/sso/:oneTimeToken', {
        template: "<p-login></p-login>"
      })
      .when('/password-reset', {
        template: "<p-password-reset></p-password-reset>"
      })
      .when('/password-reset/:passwordToken', {
        template: "<p-password-reset></p-password-reset>"
      })
      .when('/terms-of-use', {
        template: "<p-terms-of-use></p-terms-of-use>"
      })
      .when('/clients/', {
        template: "<p-client-explorer></p-client-explorer>"
      })
      .when('/clients/:clientId/:name', {
        template: "<p-client-explorer></p-client-explorer>"
      })
      .when('/clients/:clientId/:name/work/:processGroupId/:processGroupName', {
        template: "<p-process-run></p-process-run>"
      })
      .when('/clients/notes', {
        template: `<p-process-notes component="NotesComponent"></p-process-notes>`
      })
      .when('/clients/:clientId/:name/work/:processGroupId/:processGroupName/notes', {
        template: `<p-process-notes component="NotesComponent"></p-process-notes>`
      })
      .when('/stats/', {
        template: "<p-work-data></p-work-data>"
      })
      .when('/stats/me/workdata', {
        template: "<p-work-data></p-work-data>"
      })
      .when('/stats/me/flexitime', {
        template: '<p-flexitime></p-flexitime>'
      })
      .when('/stats/me/worklogs', {
        template: "<p-power-user-view></p-power-user-view>"
      })
      .when('/stats/me/overtime', {
        template: "<p-overtimes-employee></p-overtimes-employee>"
      })
      .when('/stats/me/overtimeRequest', {
        template: "<p-overtime-applications></p-overtime-applications>"
      })
      .when('/stats/team', {
        template: "<p-team-leader-view></p-team-leader-view>"
      })
      .when('/stats/team/flexitime', {
        template: '<p-flexitime team-leader-version="true"></p-flexitime>'
      })
      .when('/stats/team/worklogs', {
        template: "<p-team-leader-view></p-team-leader-view>"
      })
      .when('/stats/team/daily-report', {
        template: "<p-daily-report></p-daily-report>"
      })
      .when('/stats/team/overtimes', {
        template: "<p-overtimes></p-overtimes>"
      })
      .when('/stats/team/profitability', {
        template: "<p-profitability-view></p-profitability-view>"
      })
      .when('/stats/team/360-view', {
        template: "<p-360-view-manager></p-360-view-manager>"
      })
      .when('/stats/team/360-view/:type/:clientId', {
        template: "<p-360-view-manager></p-360-view-manager>"
      })
      .when('/stats/team/overtimeRequest', {
        template: "<p-overtime-applications></p-overtime-applications>"
      })
      .when('/management', {
        template: "<p-management></p-management>"
      })
      .when('/stats/management/export', {
        template: "<p-management></p-management>"
      })
      .when('/stats/management/profitability', {
        template: "<p-profitability-view-manager></p-profitability-view-manager>"
      })
      .when('/stats/management/360-view/shared/:id', {
        template: "<p-360-shared-view></p-360-shared-view>"
      })
      .when('/stats/management/360-view', {
        template: "<p-360-view-manager></p-360-view-manager>"
      })
      .when('/stats/management/360-view/:type/:clientId', {
        template: "<p-360-view-manager></p-360-view-manager>"
      })
      .when('/stats/management/worklogs', {
        template: "<p-team-leader-view></p-team-leader-view>"
      })
      .when('/stats/management/overtimes', {
        template: "<p-overtimes></p-overtimes>"
      })
      .when('/stats/management/overtimeRequest', {
        template: "<p-overtime-applications></p-overtime-applications>"
      })
      .when('/controlling/rates', {
        template: "<p-rates></p-rates>"
      })
      .when('/controlling/incomeImport', {
        template: "<p-income-import></p-income-import>"
      })
      .when('/controlling/export', {
        template: "<p-controlling-export></p-controlling-export>"
      })
      .when('/admin', {
        redirectTo: '/admin/countries'
      })
      .when('/admin/countries', {
        template: "<p-countries></p-countries>"
      })
      .when('/admin/countries/:name', {
        template: "<p-country></p-country>"
      })
      .when('/admin/countries/:name/process_group_configurations/:processId', {
        template: "<p-process-group-configurations></p-process-group-configurations>"
      })
      .when('/admin/interrupts', {
        template: "<p-interrupts></p-interrupts>"
      })
      .when('/admin/process_groups', {
        template: "<p-groups></p-groups>"
      })
      .when('/admin/users', {
        template: "<p-users></p-users>"
      })
      .when('/admin/clients', {
        template: "<p-clients></p-clients>"
      })
      .when('/admin/featureFlags', {
        template: "<p-feature-flags></p-feature-flags>"
      })
      .when('/admin/client_groups', {
        template: "<p-client-groups></p-client-groups>"
      })
      .when('/admin/service_lines', {
        template: "<p-service-lines></p-service-lines>"
      })
      .when('/admin/countries/:name/team/:teamId', {
        template: "<p-team></p-team>"
      })
      .when('/admin/countries/:name/team/:teamId/user/:userId', {
        template: "<p-user></p-user>"
      })
      .when('/admin/countries/:name/team/:teamId/client/:clientId', {
        template: "<p-client></p-client>"
      })
      .when('/admin/profit-centers', {
        template: "<p-admin-rates></p-admin-rates>"
      })
      .when('/admin/api', {
        template: "<p-api></p-api>"
      })
      .when('/admin/license_agreements', {
        template: "<p-license-agreements></p-license-agreements>"
      })
      .when('/admin/reports', {
        template: "<p-reports></p-reports>"
      })
      .when('/license-agreements/:agreementId/form', {
        template: "<p-license-agreement></p-license-agreement>"
      })
      .when('/license-agreement-forms/:formId', {
        template: "<p-license-agreement></p-license-agreement>"
      })
      .when('/caseman/config', {
        template: "<p-caseman-config></p-caseman-config>"
      })
      .when('/caseman/config/teams', {
        template: "<p-caseman-site-config></p-caseman-site-config>"
      })
      .when('/caseman/config/teams/:siteId/name/:siteName', {
        template: "<p-caseman-teams-config></p-caseman-teams-config>"
      })
      .when('/caseman/config/team', {
        template: "<p-caseman-team-config></p-caseman-team-config>"
      })
      .when('/caseman/config/clients', {
        template: "<p-caseman-client-config></p-caseman-client-config>"
      })
      .when('/caseman/config/clientsNew', {
        template: "<p-caseman-client-new-config></p-caseman-client-new-config>"
      })
      .when('/caseman/config/teamClients', {
        template: "<p-caseman-team-client-config></p-caseman-team-client-config>"
      })
      .when('/caseman/config/teamClientsErp', {
        template: "<p-caseman-team-client-erp></p-caseman-team-client-erp>"
      })
      .when('/caseman/config/processGroups', {
        template: "<p-caseman-pg-config></p-caseman-pg-config>"
      })
      .when('/caseman/config/processGroups/:processGroupId/name/:processGroupName/jobcode/:jobCodeId/country/:country', {
        template: "<p-caseman-process-config></p-caseman-process-config>"
      })
      .when('/caseman/config/teamProcessGroups', {
        template: "<p-caseman-team-pg-config></p-caseman-team-pg-config>"
      })
      .when('/caseman/config/projects', {
        template: "<p-caseman-project-config></p-caseman-project-config>"
      })
      .when('/caseman/config/teamProcessGroups/:processGroupId/name/:processGroupName/jobcode/:jobCodeId/country/:country', {
        template: "<p-caseman-team-process-config></p-caseman-team-process-config>"
      })
      .when('/caseman/config/users', {
        template: "<p-caseman-user-config></p-caseman-user-config>"
      })
      .when('/caseman/config/teamUsers', {
        template: "<p-caseman-team-user-config></p-caseman-team-user-config>"
      })
      .when('/caseman/matching', {
        template: "<p-caseman-match></p-caseman-match>"
      })
      .when('/caseman/matching/client/:clientId/user/:userId/name/:name', {
        template: "<p-caseman-match-process></p-caseman-match-process>"
      })
      .when('/caseman/matching/client/:clientId/user/:userId/name/:name/project/:projectId/projectName/:projectName', {
        template: "<p-caseman-match-process></p-caseman-match-process>"
      })
      .when('/caseman/matching/client/:clientId/team/:teamId/name/:name', {
        template: "<p-caseman-match-process></p-caseman-match-process>"
      })
      .when('/caseman/matching/client/:clientId/team/:teamId/name/:name/project/:projectId/projectName/:projectName', {
        template: "<p-caseman-match-process></p-caseman-match-process>"
      })
      .when('/caseman/customize/client/:clientId/user/:userId/name/:name', {
        template: "<p-caseman-customize-process></p-caseman-customize-process>"
      })
      .when('/caseman/customize/client/:clientId/user/:userId/name/:name/project/:projectId/projectName/:projectName', {
        template: "<p-caseman-customize-process></p-caseman-customize-process>"
      })
      .when('/caseman/customize/client/:clientId/team/:teamId/name/:name', {
        template: "<p-caseman-customize-process></p-caseman-customize-process>"
      })
      .when('/caseman/customize/client/:clientId/team/:teamId/name/:name/project/:projectId/projectName/:projectName', {
        template: "<p-caseman-customize-process></p-caseman-customize-process>"
      })
      .when('/caseman/sync', {
        template: "<p-caseman-sync></p-caseman-sync>"
      })
      .when('/caseman/integrationSettings', {
        template: "<p-caseman-integration-settings></p-caseman-integration-settings>"
      })
      .when('/d365/clients', {
        template: "<p-d365-clients></p-d365-clients>"
      })
      .when('/d365/processGroups', {
        template: "<p-d365-pg-config></p-d365-pg-config>"
      })
      .when('/d365/processGroups/:processGroupId/name/:processGroupName', {
        template: "<p-d365-process-config></p-d365-process-config>"
      })
      .when('/d365/interrupts', {
        template: "<p-d365-interrupts></p-d365-interrupts>"
      })
      .otherwise({
        redirectTo: '/clients/',
      });

    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });
}
